<template lang="pug">
div.contenedor
	Buzones.buzones
	Mensajes.mensajes
</template>

<script>
import Buzones from './components/buzones/buzones'
import Mensajes from './components/mensajes/mensajes'
import { mapActions } from 'vuex'
export default {
	components: {
		Buzones,
		Mensajes
	},
	data () {
		return {
			buzon: {
				Nombre: 'Entrada',
				Name: 'INBOX',
				Icono: 'fa fa-envelope'
			},
			email: 'dcanada@radiocastellon.com'
		}
	},
	created () {
		this.$store.commit('webmail/SET_CUENTA', this.email)
		this.getBuzones()
	},
	methods: {
		...mapActions({
			getBuzones: 'webmail/getListadoBuzones'
		})
	}
}
</script>

<style scoped>
.contenedor {
	display: flex;
	position: relative;
	width: 100%;
	flex-direction: row;
	margin-top: -20px;
	background-color: white;
}

.buzones {
	flex-grow: 0;
	flex-shrink: 0;
	flex-basis: 220px;
	max-width: 220px;
	width: 220px;
	padding: 15px;
}
.mensajes {
	flex-grow: 1;
	flex-shrink: 1;
}
</style>


// WEBPACK FOOTER //
// src/modulos/webmail/vue/webmail.component.vue